import {
  AppNameTextOpts
} from "./chunk-J2XSX3HI.js";
import {
  AppTagline
} from "./chunk-EWCNTEL6.js";

// src/components/header/Logo.tsx
import { Link, styled } from "@mui/material";
import { jsx, jsxs } from "react/jsx-runtime";
var LogoGrid = styled("span")`
    display: grid;
    grid-template-columns: repeat(4, auto);
    align-items: center;
    gap: ${({ theme }) => theme.spacing(1)};

    &:hover [class$="-${AppNameTextOpts.name}-${AppNameTextOpts.slot}"] {
        text-decoration: none;
        display: inline-block;
    },
`;
var DecorationlessAnchor = styled(Link)`
    &&:hover {
        text-decoration: none;
        color: ${({ theme }) => theme.palette.text.primary};
    }
    text-decoration: none;
    color: ${({ theme }) => theme.palette.text.primary};
`;
function ConditionalAnchorWrapper(props) {
  return props.href ? /* @__PURE__ */ jsx(DecorationlessAnchor, { href: props.href, rel: "noopener noreferrer", children: props.children }) : props.children;
}
function Logo(props) {
  return /* @__PURE__ */ jsx(ConditionalAnchorWrapper, { href: props.href, children: /* @__PURE__ */ jsxs(LogoGrid, { className: props.className, children: [
    props.children,
    props.label,
    props.label && props.tagline ? props.separator ? props.separator : /* @__PURE__ */ jsx(AppTagline, { children: "\u2014" }) : null,
    props.tagline
  ] }) });
}

export {
  ConditionalAnchorWrapper,
  Logo
};
//# sourceMappingURL=chunk-WYIG2UKD.js.map